import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IImageFile } from 'interfaces/files';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES}.${BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DESCRIPTION}` as const;

export const PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES = {
  PRODUCTS_OR_SERVICES_AND_THEIR_PURPOSE: 'productsOrServicesAndTheirPurpose',
  KEY_FEATURES_AND_BENEFITS: 'keyFeaturesAndBenefits',
  QUALITY_CERTIFICATIONS: 'qualityCertifications',
  QUALITY_STANDARDS: 'qualityStandards',
  PATENTS_OR_TRADEMARKS: 'patentsOrTrademarks',
} as const;

export const PRODUCT_AND_SERVICES_ARRAY_NAMES = {
  FILE: 'file',
  VALUE: 'value',
  DESCRIPTION: 'description',
} as const;

export const KEY_FEATURES_NAMES = {
  FEATURE: 'feature',
  DESCRIPTION: 'description',
} as const;

export interface IKeyFeaturesItem {
  [KEY_FEATURES_NAMES.FEATURE]: string;
  [KEY_FEATURES_NAMES.DESCRIPTION]: string;
}

export const keyFeaturesRowInitialValue: IKeyFeaturesItem = {
  [KEY_FEATURES_NAMES.FEATURE]: '',
  [KEY_FEATURES_NAMES.DESCRIPTION]: '',
};

export interface IProductAndServicesArray {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.FILE]: IImageFile[];
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: string;
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: string | IKeyFeaturesItem[];
}

export const productAndServicesArrayInitialValues: IProductAndServicesArray = {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.FILE]: [],
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: '',
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: [],
};

export interface IProductAndServicesDescriptionForm {
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PRODUCTS_OR_SERVICES_AND_THEIR_PURPOSE]: string;
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.KEY_FEATURES_AND_BENEFITS]: IProductAndServicesArray[];
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_STANDARDS]: string;
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_CERTIFICATIONS]: IProductAndServicesArray[];
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PATENTS_OR_TRADEMARKS]: IProductAndServicesArray[];
}

export const productAndServicesDescriptionInitialValues: IProductAndServicesDescriptionForm = {
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PRODUCTS_OR_SERVICES_AND_THEIR_PURPOSE]: '',
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.KEY_FEATURES_AND_BENEFITS]: [productAndServicesArrayInitialValues],
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_STANDARDS]: '',
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_CERTIFICATIONS]: [productAndServicesArrayInitialValues],
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PATENTS_OR_TRADEMARKS]: [productAndServicesArrayInitialValues],
};
